// extracted by mini-css-extract-plugin
var _1 = "VersionChangesDropdown-module__animateUploadProgressBarWidth--U24KZ";
var _2 = "VersionChangesDropdown-module__animatedBackground--UJ_4I";
var _3 = "VersionChangesDropdown-module__calendarDay--IdKyS";
var _4 = "VersionChangesDropdown-module__calendarDayWeekday--FMqWN";
var _5 = "VersionChangesDropdown-module__dropdownContent--bbjxp";
var _6 = "VersionChangesDropdown-module__dropdownRow--ALliH";
var _7 = "VersionChangesDropdown-module__dropdownRowCalendarDay--JdxDo";
var _8 = "VersionChangesDropdown-module__dropdownRowContent--WS87N";
var _9 = "VersionChangesDropdown-module__dropdownRowSubtitle--Sg5PO";
var _a = "VersionChangesDropdown-module__dropdownRowTitle--sx5Zk";
var _b = "VersionChangesDropdown-module__restrictedHistories--vYLBW";
var _c = "VersionChangesDropdown-module__sectionTitle--dE9ne";
var _d = "VersionChangesDropdown-module__sectionTitleBadge--RvuoD";
var _e = "VersionChangesDropdown-module__versionChangesDropdownButton--z5Ph8";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "calendarDay", _4 as "calendarDayWeekday", _5 as "dropdownContent", _6 as "dropdownRow", _7 as "dropdownRowCalendarDay", _8 as "dropdownRowContent", _9 as "dropdownRowSubtitle", _a as "dropdownRowTitle", _b as "restrictedHistories", _c as "sectionTitle", _d as "sectionTitleBadge", _e as "versionChangesDropdownButton" }
